module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-b1975288.png";